import { Feature } from '@/pinia/feature'

export const buildingScore: Feature = {
  name: 'buildingscore',
  enabled: true,
  access: ['FEAT_BUILDING-SCORE_READER'],
  title: {
    en: 'Building score',
    sv: 'Building score'
  },
  component: 'DashboardFeatureBuildingScore',
  isRoute: true,
  props: {
    icon: 'IconAward'
  },
  children: [
    {
      name: 'kpis',
      enabled: true,
      title: {
        en: 'KPIs',
        sv: 'KPIer'
      },
      component: 'BuildingScoreKpiSection',
      isRoute: true,
      children: [
        {
          name: 'colorlegend',
          enabled: true,
          title: {
            en: 'Building score',
            sv: 'Building score'
          },
          props: {
            type: 'categorical',
            colors: [
              {
                color: '#FF4D4F',
                label: {
                  en: 'Red',
                  sv: 'Röd'
                }
              },
              {
                color: '#40A9FF',
                label: {
                  en: 'Blue',
                  sv: 'Blå'
                }
              },
              {
                color: '#73D13D',
                label: {
                  en: 'Green',
                  sv: 'Grön'
                }
              }
            ],
            width: 150,
            height: 34
          }
        }
      ]
    },
    {
      name: 'graphs',
      enabled: true,
      title: {
        en: 'Graphs',
        sv: 'Grafer'
      },
      component: 'BuildingScoreGraphSection',
      isRoute: true,
      props: {
        dataSources: [
          {
            id: 'buildingscore.chart.attractiveness',
            type: 'fetch',
            fetch: 'fetch.buildingscore.timeseries',
            path: 'datasets[0]'
          },
          {
            id: 'buildingscore.chart.condition',
            type: 'fetch',
            fetch: 'fetch.buildingscore.timeseries',
            path: 'datasets[1]'
          }
        ]
      },
      children: [
        {
          name: 'charts',
          enabled: true,
          title: {
            en: 'Charts',
            sv: 'Grafer'
          },
          children: [
            {
              name: 'buildingscore',
              enabled: true,
              title: {
                en: 'Change over time',
                sv: 'Förändring över tid'
              },
              info: {
                en: 'The graph depicts changes in attractiveness and condition over the years.',
                sv: 'Grafen illustrerar förändringarna i attraktivitet och skick över åren.'
              },
              props: {
                type: 'timeseries',
                gradientBelow: true,
                dataTicks: {
                  values: [1, 2, 3]
                },
                dataFormat: {
                  format: {
                    type: 'intl-number',
                    useGrouping: false,
                    maximumFractionDigits: 1
                  }
                },
                timeFormat: {
                  format: {
                    type: 'intl-datetime',
                    year: 'numeric'
                  }
                },
                labels: [
                  {
                    sv: 'Attraktivitet',
                    en: 'Attractiveness'
                  },
                  {
                    sv: 'Skick',
                    en: 'Condition'
                  }
                ],
                lineFormats: [
                  {
                    color: '#40A9FF',
                    style: 'solid'
                  },
                  {
                    color: '#9254DE',
                    style: 'solid'
                  }
                ],
                dataSources: ['buildingscore.chart.attractiveness', 'buildingscore.chart.condition']
              }
            }
          ]
        }
      ]
    }
  ]
}
